
import { CoreFormatCoupon } from '@tencent/wphk-act-base-framework';
import { CouponType } from '@tencent/wphk-act-base-types';

/**
 * 奖品批次 → 切图映射 (硬编码)
 *
 * 说明：
 * - 因为奖品使用切图展示，需要根据接口返回的 prizeId (batchId) 映射到对应图片
 * - prizeId 由营销平台配置，需与运营确认后填入
 * - 如果 prizeId 未匹配到，使用 fallback 默认图片
 *
 * TODO: 与运营确认 5 种奖品对应的 prizeId 后更新
 */
export const PRIZE_BATCH_IMAGE_MAP: Record<string, string> = {
  // HK$88 优惠券
  CP4451202512290162: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20251230144530/new88.png',

  // HK$8 优惠券
  CP4451202512291705: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20251230144530/new8.png',

  // HK$668 优惠券
  CP4451202512293813: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20251230144530/new668.png',

  // HK$1 优惠券
  CP4451202512297563: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20251230144530/new1.png',

  // HK$2 展示券 (兜底)
  SC4451202512244964: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20251230144530/new2.png',
};


/**
 * 根据 prizeId 获取奖品图片
 * @param prizeId 接口返回的奖品批次 ID
 * @returns 对应的奖品切图 URL
 */
export const getPrizeImageByBatch = (prizeId: string): string => PRIZE_BATCH_IMAGE_MAP[prizeId] ;

export const isDisplayCoupon = (couponType?: CouponType): boolean => CoreFormatCoupon.isSpType(couponType);

